export const ANIMATION = {
  none: { enter: 'off', exit: 'off' },
  // pushRight: { enter: 'push-right', exit: 'push-right', pageTransitionClassName: 'D(f) Fxd(r)' },
  // pushLeft: { enter: 'push-left', exit: 'push-left', pageTransitionClassName: 'D(f) Fxd(r)' },
  fadeIn: { enter: 'fade-in-out', exit: 'off' },
  fadeOut: { enter: 'off', exit: 'fade-in-out' },
  zoomIn: { enter: 'recs-zoom', exit: 'fade-in-out' },
  slideInRight: { enter: 'slide-in-right', exit: 'off' },
  slideOutRight: { enter: 'off', exit: 'slide-out-right' },
  slideInLeft: { enter: 'slide-in-left', exit: 'off' },
  slideOutLeft: { enter: 'off', exit: 'slide-out-left' },
  slideInUp: { enter: 'slide-in-up', exit: 'off' },
  slideOutDown: { enter: 'off', exit: 'slide-out-down' },
};

export const mobileAnimation = {
  initial: 0,
  fromLeft: 1,
  fromRight: 2,
  fade: 3,
  zoom: 4,
  slideUp: 5,
};

export const desktopCanvasAnimation = {
  initial: 0,
  fade: 1,
  fromRight: 2,
};

export const desktopSideAnimation = {
  initial: 0,
  fromLeft: 1,
  fromRight: 2,
};
